import React from 'react'
import ReactDOM from 'react-dom'
import withReduxFeatures from './withReduxFeatures'
import App from './components/App'

import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/alert'
// import './utils/jquery.magnific-popup-update'


// import App from './App'
import './index.scss'
import * as serviceWorker from './serviceWorker'
// import CityRedirect from './features/getCities'

/** Wrap App component with store providers */
const WrappedApp = withReduxFeatures(App)

ReactDOM.render(<WrappedApp/>, document.getElementById('root'))

// const cityRedirect = new CityRedirect()
// ReactDOM.render(
//   <React.StrictMode>
//     <App/>
//   </React.StrictMode>,
//   document.getElementById('root')
// )

/**
 * If you want your app to work offline and load faster,
 * you can change unregister() to register() below.
 * Note this comes with some pitfalls.
 * @see https://bit.ly/CRA-PWA
 */
serviceWorker.unregister()
